<template>
<v-snackbar :timeout="0" :top="true" v-model="visible" color="secondary">{{ text }}</v-snackbar>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    text: {
      type: String
    },
    timeout: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      visible: false,
      timeoutHandler: null
    }
  },
  watch: {
    text(val) {
      if (val) {
        this.visible = true;
        if (this.timeoutHandler)
          clearTimeout(this.timeoutHandler);
        this.timeoutHandler = setTimeout(() => {
          this.textToast = '';
          this.visible = false;
        }, this.timeout);
      }
    }
  },
  computed: {
    textToast: {
      get() {
        return this.text;
      },
      set(val) {
        this.$emit('update:text', val);
      }
    }
  }
}
</script>
